// Module
var code = `<div class="page"> <div class="panel"> <span class="panel_title">PAY</span> <p class="panel_subtitle">This page should be used as a way for people to easily pay contractors. Ideally it should be handled by AnPost Money.</p> </div> </div>`;
// Exports
export default code;